import request from '@/utils/request'

export function getPaymentConfig() {
  return request.get('/pay/config')
}

export function createPay(data) {
  return request.post('/pay/create', data)
}

export function getOrderStatus(orderNo, channel) {
  const params = { orderNo }
  if (channel) {
    params.channel = channel
  }
  return request.get('/pay/order/status', { params })
}
